import React from "react";
import { CartProductOptions } from "./CartProductOptions";

export const CartTableProduct = ({ item }) => {

  if (!item) {
    return false;
  }

    const line_item_price = item.price / 100;
    const show_total_price = true;
    // @ts-ignore
    const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
    let totalDiscount = 0;
    if (item.discounts) {
        item.discounts.forEach((discount) => {
            totalDiscount += discount.amount;
        });
    }

  return (
    <div className="product-thumb-wrapper flex">
      <a href={item.url}>
        <img
          src={item.image}
          alt={item.title}
          className="w-[80px] h-[100px] object-cover"
          loading="lazy"
        />
      </a>
        <div className="product-details p-4 flex flex-col">
            <a href={item.url} className="product-title">{item.product_title}</a>
            <div className="product-price b3">
                {currencySymbol}{line_item_price / 100}
                <p className={`max-lg:text-xs font-normal line-through text-[#BBBBBD]`}>
                    {currencySymbol}
                    {(item.original_line_price / 100)}
                </p>
            </div>
            {item.selling_plan_allocation && (
                <div className="product-selling-plan b3">
                    {item.selling_plan_allocation.selling_plan.name}
                </div>
            )}

            <div className={'discounts_applied'}>
                {item.discounts.map((discount, id) => {
                    return (
                        <React.Fragment key={id}>
                            <p className={"brs text-red-500"}>
                                {discount.title}</p>
                        </React.Fragment>
                    );
                })}
            </div>
            <div className="product-options b3">
                {CartProductOptions(item.options_with_values)}
            </div>
        </div>
    </div>
  );
};
